import { ajax } from "jquery";

type HttpMethod = "GET" | "POST" | "DELETE";

export function ajaxRequest<T>(method: HttpMethod, action: string, data: Record<string, any> = {}): Promise<T> {
	const { ajax_url, nonces } = window.innosend_client;

	return new Promise((resolve, reject) => {
		const options: JQueryAjaxSettings = {
			url: ajax_url,
			method: method,
			data: { action, nonce: nonces[action], ...data },
			dataType: "json"
		};

		ajax(options)
			.done((response: T) => resolve(response))
			.fail((jqXHR, textStatus, errorThrown) => {
				console.error("AJAX request failed: ", jqXHR, textStatus, errorThrown);
				reject(new Error(`AJAX request failed: ${textStatus}`));
			});
	});
}
